import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LeadListsPage } from "@/features/leadlists/ListsPage";

const search = z.object({
  peek: z.string().optional(),
  view: z.enum(["lists", "leads", "suppression"]).optional(),
});

export const Route = createFileRoute("/_app/outreach/lists")({
  validateSearch: search,
  component: () => <LeadListsPage search={Route.useSearch()} />,
});
